export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--logout.efad8558.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};